// extracted by mini-css-extract-plugin
module.exports =  {"root":"PyY24If0dtRg_s10W2QF","label":"PcOxyu9bC37pPpCj1pBA","icon":"BtEPJPsPUhsFIGMZYFh_"};